<template>
    <ProcessedApplication v-if="this.hasProcessedApplication" 
        :application="this.processedApplication"
        :shouldRequestCreditScore="this.applicationSettings.isUserAuthenticated && this.applicationSettings.isUserVerified"
        :mustRedirect="!!this.applicationSettings.mustRedirect"
        :memberPortalUrl="this.applicationSettings.portalBaseUrl"/>
</template>

<script>

import { inject } from 'vue';
import ProcessedApplication from '@/components/ProcessedApplication.vue';

export default {
    name: 'FinalFlow',
    emits: ["update:application-settings","update:component-settings"],
    setup() {
        const { processedApplication } = inject('app'); // app is being provided in Application.vue
        return {
            processedApplication
        }
    },
    components: {
        ProcessedApplication
    },
    props: {
        applicationSettings: {
            type: Object,
            required: true,
        },
        componentSettings: {
            type: Object,
            required: true,
        },
    },
    data: () => {
        const testData = true;
        return {
            testData,
        };
    },
    methods: {
        testMethod() {
            this.testData = false;
        }
    },
    computed: {
        testComputed() {
            return true;
        },
        hasProcessedApplication() {
            return !!this.processedApplication && Object.keys(this.processedApplication).length > 0;
        },
    },
    created() {
        // console.log('FinalFlow created');
    },
    mounted() {
        // console.log('FinalFlow mounted');
    },
    watch: {
    }
};
</script>